export const categories = [
  { id: 1, name: '国漫', slug: 'guoman', icon: 'ri-china-railway-line', description: '国产漫画精品，支持原创' },
  { id: 2, name: '日漫', slug: 'riman', icon: 'ri-sun-line', description: '经典日系漫画连载' },
  { id: 3, name: '韩漫', slug: 'hanman', icon: 'ri-flag-line', description: '韩系条漫，下拉阅读' },
  { id: 4, name: '热血', slug: 'rexue', icon: 'ri-fire-line', description: '燃爆全场的战斗漫画' },
  { id: 5, name: '恋爱', slug: 'lianai', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱故事' },
  { id: 6, name: '玄幻', slug: 'xuanhuan', icon: 'ri-moon-line', description: '奇幻仙侠修真世界' },
  { id: 7, name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', description: '欢乐解压搞笑漫画' },
  { id: 8, name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line', description: '烧脑推理悬疑佳作' },
  { id: 9, name: '都市', slug: 'dushi', icon: 'ri-building-line', description: '现代都市生活漫画' },
  { id: 10, name: '科幻', slug: 'kehuan', icon: 'ri-rocket-line', description: '未来科幻想象世界' },
];

export const comics = [
  {
    id: 1,
    title: '斗破苍穹',
    author: '天蚕土豆',
    category: 'xuanhuan',
    categories: ['xuanhuan', 'rexue'],
    status: '连载中',
    rating: 9.6,
    views: '1.2亿',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Chinese%20manhua%20cover%20art%20featuring%20a%20young%20swordsman%20in%20flowing%20martial%20robes%20surrounded%20by%20mystical%20flames%20and%20ancient%20ruins%2C%20epic%20fantasy%20illustration%20style%20with%20dramatic%20lighting%2C%20warm%20orange%20and%20gold%20color%20palette%2C%20clean%20composition%20on%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后突然成了废人，种种打击接踵而至。就在他即将绝望之时，一缕幽魂从他手上的戒指里浮现，一扇全新的大门在面前开启！',
    chapters: 1245,
    updatedAt: '2026-08-03',
    tags: ['玄幻', '热血', '战斗', '异世界'],
  },
  {
    id: 2,
    title: '一人之下',
    author: '米二',
    category: 'guoman',
    categories: ['guoman', 'rexue', 'xuanyi'],
    status: '连载中',
    rating: 9.7,
    views: '9800万',
    cover: 'https://readdy.ai/api/search-image?query=A%20modern%20Chinese%20urban%20fantasy%20manhua%20cover%20showing%20a%20mysterious%20young%20man%20with%20supernatural%20abilities%20in%20a%20city%20alleyway%2C%20traditional%20Taoist%20elements%20blending%20with%20contemporary%20setting%2C%20dramatic%20chiaroscuro%20lighting%2C%20dark%20teal%20and%20crimson%20accents%2C%20cinematic%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '随着父亲失踪，神秘少女冯宝宝的造访，少年张楚岚的平静校园生活被彻底颠覆。一个关于异人的世界在他面前徐徐展开。',
    chapters: 682,
    updatedAt: '2026-08-02',
    tags: ['都市', '异能', '道术', '悬疑'],
  },
  {
    id: 3,
    title: '咒术回战',
    author: '芥见下下',
    category: 'riman',
    categories: ['riman', 'rexue'],
    status: '连载中',
    rating: 9.5,
    views: '1.5亿',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20cover%20art%20featuring%20a%20powerful%20sorcerer%20with%20glowing%20eyes%20and%20flowing%20dark%20hair%2C%20surrounded%20by%20cursed%20energy%20auras%20in%20deep%20purple%20and%20blue%20tones%2C%20dynamic%20action%20pose%2C%20shonen%20manga%20aesthetic%20with%20bold%20ink%20lines%2C%20dramatic%20contrast%20on%20minimal%20background&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '少年虎杖悠仁吞下诅咒之王的手指后，踏入了咒术师的世界。为了收集散落的诅咒之王手指，他与伙伴们一起踏上了讨伐咒灵的战斗之路。',
    chapters: 271,
    updatedAt: '2026-08-01',
    tags: ['战斗', '咒术', '校园', '黑暗'],
  },
  {
    id: 4,
    title: '我独自升级',
    author: 'Chugong',
    category: 'hanman',
    categories: ['hanman', 'rexue', 'xuanhuan'],
    status: '已完结',
    rating: 9.8,
    views: '2.1亿',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20webtoon%20cover%20featuring%20a%20lone%20hunter%20with%20glowing%20purple%20eyes%20and%20shadow%20army%20rising%20behind%20him%2C%20dark%20gothic%20fantasy%20style%20with%20dramatic%20backlight%2C%20monochrome%20with%20violet%20accents%2C%20imposing%20composition%20on%20subtle%20gradient%20background&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '在被称为"人类最弱兵器"的E级猎人成振宇面前，出现了一个神秘的任务窗口。从此，只有他能够不断"升级"，踏上成为最强猎人的道路。',
    chapters: 179,
    updatedAt: '2026-07-28',
    tags: ['升级', '战斗', '暗影', '系统'],
  },
  {
    id: 5,
    title: '狐妖小红娘',
    author: '小新',
    category: 'guoman',
    categories: ['guoman', 'lianai', 'xuanhuan'],
    status: '连载中',
    rating: 9.4,
    views: '8900万',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20romantic%20fantasy%20manhua%20cover%20showing%20a%20fox%20spirit%20maiden%20with%20flowing%20pink%20silk%20robes%20and%20cherry%20blossoms%2C%20traditional%20Chinese%20ink%20painting%20style%20blended%20with%20modern%20illustration%2C%20soft%20pastel%20pink%20and%20gold%20color%20scheme%2C%20ethereal%20atmosphere&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '根据古典小说记载，世上有人有妖，妖会与人相恋。妖寿命千万年，人的寿命有限。人死之后投胎转世，不记得上辈子的爱。妖如果痴情的话，就去找狐妖"购买"一项服务，让投胎转世的人回忆起前世的爱。',
    chapters: 526,
    updatedAt: '2026-08-03',
    tags: ['爱情', '仙侠', '转世', '治愈'],
  },
  {
    id: 6,
    title: '间谍过家家',
    author: '远藤达哉',
    category: 'riman',
    categories: ['riman', 'gaoxiao', 'dushi'],
    status: '连载中',
    rating: 9.6,
    views: '1.1亿',
    cover: 'https://readdy.ai/api/search-image?query=A%20charming%20Japanese%20manga%20cover%20depicting%20a%20stylish%20family%20of%20three%20in%20formal%20attire%20against%20a%20retro%20European%20cityscape%2C%20warm%20and%20playful%20illustration%20style%20with%20clean%20lines%2C%20soft%20cream%20and%20burgundy%20color%20palette%2C%20heartwarming%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '为了执行任务，最强间谍"黄昏"组建了一个临时家庭。然而，他的"女儿"是超能力者，"妻子"是杀手。互相隐藏身份的三人的共同生活，就此展开！',
    chapters: 105,
    updatedAt: '2026-08-02',
    tags: ['家庭', '喜剧', '间谍', '日常'],
  },
  {
    id: 7,
    title: '女神降临',
    author: 'Yaongyi',
    category: 'hanman',
    categories: ['hanman', 'lianai', 'dushi'],
    status: '已完结',
    rating: 9.3,
    views: '7600万',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylish%20Korean%20webtoon%20cover%20showing%20a%20beautiful%20young%20woman%20doing%20makeup%20with%20cosmetics%20scattered%20around%2C%20split%20image%20showing%20before%20and%20after%20transformation%2C%20modern%20fashion%20illustration%20style%2C%20soft%20rose%20and%20beige%20tones%2C%20elegant%20composition%20on%20clean%20background&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '通过化妆术从丑小鸭变身为校园女神的女主角，在校园里经历友情与爱情的故事。素颜的秘密能否永远守护？',
    chapters: 238,
    updatedAt: '2026-07-15',
    tags: ['校园', '恋爱', '化妆', '成长'],
  },
  {
    id: 8,
    title: '完美世界',
    author: '辰东',
    category: 'xuanhuan',
    categories: ['xuanhuan', 'rexue'],
    status: '连载中',
    rating: 9.5,
    views: '1.3亿',
    cover: 'https://readdy.ai/api/search-image?query=An%20epic%20Chinese%20fantasy%20manhua%20cover%20depicting%20a%20powerful%20young%20cultivator%20standing%20atop%20a%20mountain%20peak%20with%20celestial%20beasts%20flying%20in%20the%20sky%2C%20ancient%20mythological%20Chinese%20art%20style%20with%20modern%20rendering%2C%20golden%20and%20jade%20green%20color%20palette%2C%20majestic%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '一粒尘可填海，一根草斩尽日月星辰，弹指间天翻地覆。群雄并起，万族林立，诸圣争霸，乱天动地。少年石昊自大荒中走出，一切从这里开始。',
    chapters: 987,
    updatedAt: '2026-08-03',
    tags: ['玄幻', '仙侠', '修行', '神话'],
  },
  {
    id: 9,
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    category: 'riman',
    categories: ['riman', 'rexue'],
    status: '已完结',
    rating: 9.7,
    views: '1.8亿',
    cover: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20Japanese%20manga%20cover%20featuring%20a%20young%20demon%20slayer%20with%20a%20nichirin%20blade%20under%20moonlight%2C%20water%20breathing%20technique%20visualized%20as%20flowing%20blue%20waves%2C%20traditional%20Japanese%20woodblock%20print%20influence%2C%20deep%20indigo%20and%20crimson%20color%20scheme%2C%20dynamic%20action%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '大正时期，卖炭少年炭治郎的家人惨遭鬼的杀害。唯一幸存的妹妹祢豆子却变成了鬼。为了让妹妹变回人类，讨伐杀害家人的鬼，少年踏上了斩鬼之旅。',
    chapters: 205,
    updatedAt: '2026-06-20',
    tags: ['战斗', '鬼怪', '热血', '兄妹'],
  },
  {
    id: 10,
    title: '镇魂街',
    author: '许辰',
    category: 'guoman',
    categories: ['guoman', 'rexue', 'xuanhuan'],
    status: '连载中',
    rating: 9.4,
    views: '7200万',
    cover: 'https://readdy.ai/api/search-image?query=A%20gritty%20Chinese%20urban%20fantasy%20manhua%20cover%20showing%20a%20spirit%20guardian%20warrior%20in%20ancient%20armor%20standing%20in%20a%20modern%20city%20street%20at%20night%2C%20supernatural%20energy%20crackling%20around%2C%20dark%20atmosphere%20with%20neon%20accents%2C%20cool%20steel%20blue%20and%20amber%20color%20palette%2C%20cinematic%20noir%20composition&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '普通的应届大学毕业生夏铃在求职之际，收到了一条奇怪的面试通知，因此误入罗刹街并遭到了危险。幸而被镇魂将曹焱兵搭救。然而接触中，曹焱兵却发现夏铃并非看起来那样普通。',
    chapters: 438,
    updatedAt: '2026-08-01',
    tags: ['都市', '战斗', '守护灵', '热血'],
  },
  {
    id: 11,
    title: '整容游戏',
    author: '金丘',
    category: 'hanman',
    categories: ['hanman', 'xuanyi', 'dushi'],
    status: '已完结',
    rating: 9.2,
    views: '5100万',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20webtoon%20cover%20showing%20a%20smartphone%20screen%20glowing%20with%20a%20creepy%20beauty%20app%20interface%2C%20a%20woman%20face%20half%20in%20shadow%20half%20illuminated%2C%20psychological%20thriller%20atmosphere%2C%20dark%20mauve%20and%20silver%20color%20scheme%2C%20unsettling%20yet%20beautiful%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '一款名为"整容游戏"的神秘APP出现在女主角的手机上。通过完成各种任务，她可以改变自己的外貌。但这背后隐藏着怎样的阴谋？',
    chapters: 132,
    updatedAt: '2026-05-30',
    tags: ['悬疑', '惊悚', '手机App', '人性'],
  },
  {
    id: 12,
    title: '非人哉',
    author: '一汪空气',
    category: 'guoman',
    categories: ['guoman', 'gaoxiao', 'dushi'],
    status: '连载中',
    rating: 9.3,
    views: '6500万',
    cover: 'https://readdy.ai/api/search-image?query=A%20humorous%20Chinese%20slice-of-life%20manhua%20cover%20depicting%20mythological%20creatures%20and%20deities%20living%20in%20modern%20urban%20setting%2C%20cute%20and%20playful%20illustration%20style%20with%20bright%20colors%2C%20nine-tailed%20fox%20working%20in%20office%2C%20light%20pastel%20background%20with%20warm%20yellow%20and%20coral%20accents%2C%20cheerful%20composition&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '九尾狐九月、龙王三太子敖烈、哪吒等传说中的神仙妖怪，在现代都市里过着爆笑的日常生活。什么神仙下凡，不过是来当社畜罢了！',
    chapters: 812,
    updatedAt: '2026-08-02',
    tags: ['搞笑', '日常', '神话', '四格'],
  },
];

export const reviews = [
  { id: 1, user: '漫画迷小王', avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cute%20anime%20style%20avatar%20icon%20of%20a%20young%20person%20with%20warm%20smile%2C%20minimalist%20flat%20illustration%2C%20clean%20soft%20pastel%20background&width=80&height=80&seq=avatar-01&orientation=squarish', rating: 5, content: '飞飞漫画真的是我用过最好的免费漫画网站！更新快，画质清晰，下拉式阅读体验超级流畅，再也不用翻页等待了！强烈推荐！', date: '2026-07-28' },
  { id: 2, user: '二次元少女', avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cute%20anime%20style%20girl%20avatar%20icon%20with%20pink%20hair%2C%20minimalist%20flat%20illustration%2C%20clean%20soft%20pastel%20background&width=80&height=80&seq=avatar-02&orientation=squarish', rating: 5, content: '资源太全了！国漫日漫韩漫都能找到，而且完全免费。每天晚上都要刷几个小时，感谢飞飞漫画陪伴我的每一个夜晚！', date: '2026-07-25' },
  { id: 3, user: '追更达人', avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cool%20anime%20style%20boy%20avatar%20icon%20with%20glasses%2C%20minimalist%20flat%20illustration%2C%20clean%20soft%20pastel%20background&width=80&height=80&seq=avatar-03&orientation=squarish', rating: 5, content: '更新速度和官方同步，基本第一时间就能看到最新章。收藏功能也很方便，追更不迷路！飞飞漫画yyds！', date: '2026-07-22' },
  { id: 4, user: '漫画老司机', avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20mature%20anime%20style%20avatar%20icon%20of%20a%20person%20with%20beard%2C%20minimalist%20flat%20illustration%2C%20clean%20soft%20pastel%20background&width=80&height=80&seq=avatar-04&orientation=squarish', rating: 4, content: '看了十几年漫画了，飞飞漫画的排版和阅读体验确实做得不错。分类也很清晰，找漫画很方便。希望继续保持！', date: '2026-07-20' },
  { id: 5, user: '小新的蜡笔', avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cute%20anime%20style%20avatar%20icon%20of%20a%20young%20girl%20with%20twin%20tails%2C%20minimalist%20flat%20illustration%2C%20clean%20soft%20pastel%20background&width=80&height=80&seq=avatar-05&orientation=squarish', rating: 5, content: '下拉式阅读真的太爽了！一口气看完一整话，不用一直点下一页。漫画种类也很多，从热血到恋爱应有尽有。', date: '2026-07-18' },
  { id: 6, user: '夜猫子读者', avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20sleepy%20anime%20style%20avatar%20icon%20with%20dark%20hair%2C%20minimalist%20flat%20illustration%2C%20clean%20soft%20pastel%20background&width=80&height=80&seq=avatar-06&orientation=squarish', rating: 5, content: '半夜睡不着就来飞飞漫画看漫画，界面不刺眼，阅读体验很舒服。比那些要付费的app好用多了！', date: '2026-07-15' },
];

export const faqs = [
  { question: '飞飞漫画网的漫画都是免费的吗？', answer: '是的！飞飞漫画网所有漫画均免费提供在线观看，无需注册付费，真正做到零门槛畅读海量优质漫画。' },
  { question: '什么是下拉式阅读？', answer: '下拉式阅读是一种全新的漫画阅读方式，将整话漫画内容以纵向排列，读者只需向下滑动即可连续阅读，无需频繁翻页，体验更加流畅自然。' },
  { question: '网站上的漫画多久更新一次？', answer: '飞飞漫画网与各大漫画平台同步更新，热门漫画通常在官方更新后24小时内即可在本站阅读，让大家追更无忧。' },
  { question: '支持手机端阅读吗？', answer: '完全支持！飞飞漫画网采用响应式设计，无论是在电脑、平板还是手机上，都能获得极佳的阅读体验。' },
  { question: '如何找到我想看的漫画？', answer: '您可以通过首页的搜索功能直接搜索漫画名称，也可以通过分类导航按类型浏览，还可以查看热门推荐和最新更新来发现好漫画。' },
  { question: '网站有App可以下载吗？', answer: '目前飞飞漫画网主要通过网页端提供阅读服务，您可以直接在浏览器中访问。我们将持续优化移动端体验，让阅读更加便捷。' },
];

export const heroSlides = [
  {
    id: 1,
    comicId: 4,
    title: '我独自升级',
    subtitle: '全网最热！2.1亿次阅读',
    description: '从最弱到最强，暗影君主的传奇之路',
    bg: 'https://readdy.ai/api/search-image?query=A%20dark%20epic%20fantasy%20art%20banner%20featuring%20a%20lone%20warrior%20silhouette%20surrounded%20by%20shadow%20soldiers%2C%20dramatic%20purple%20and%20black%20color%20scheme%2C%20stylized%20digital%20art%20with%20atmospheric%20lighting%2C%20wide%20cinematic%20composition%2C%20suitable%20for%20web%20hero%20banner&width=1600&height=700&seq=hero-bg-01&orientation=landscape',
  },
  {
    id: 2,
    comicId: 1,
    title: '斗破苍穹',
    subtitle: '连载突破1200话！玄幻经典',
    description: '三十年河东三十年河西，莫欺少年穷！',
    bg: 'https://readdy.ai/api/search-image?query=An%20epic%20Chinese%20fantasy%20art%20banner%20with%20a%20young%20cultivator%20surrounded%20by%20mystical%20flames%20and%20ancient%20floating%20islands%2C%20warm%20golden%20and%20orange%20color%20palette%2C%20dramatic%20skyscape%2C%20cinematic%20wide%20composition%20for%20web%20hero%20section&width=1600&height=700&seq=hero-bg-02&orientation=landscape',
  },
  {
    id: 3,
    comicId: 9,
    title: '鬼灭之刃',
    subtitle: '现象级日漫，感动亿万读者',
    description: '兄妹的羁绊，斩鬼的意志，永不熄灭的火焰',
    bg: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20anime%20style%20art%20banner%20showing%20a%20demon%20slayer%20with%20water%20breathing%20technique%20under%20full%20moon%2C%20traditional%20Japanese%20aesthetic%20with%20flowing%20blue%20waves%2C%20stylized%20digital%20illustration%2C%20wide%20composition%20for%20hero%20banner&width=1600&height=700&seq=hero-bg-03&orientation=landscape',
  },
];